import {
  KpiGrid,
  KpiCard,
  KpiCardBankDetails,
  KpiCardSynced1C,
  KpiCardSuppliers,
  KpiLabel,
  KpiValue,
  KpiSub,
} from './styled';
import type { CounterpartyKpiMetrics } from './types';

interface CounterpartyKpiGridProps {
  metrics: CounterpartyKpiMetrics;
}

export function CounterpartyKpiGrid({ metrics }: CounterpartyKpiGridProps) {
  return (
    <KpiGrid>
      <KpiCard>
        <KpiLabel>Всего контрагентов</KpiLabel>
        <KpiValue>{metrics.totalCount}</KpiValue>
        <KpiSub>В мастер-справочнике</KpiSub>
      </KpiCard>
      <KpiCardBankDetails>
        <KpiLabel>С полными реквизитами</KpiLabel>
        <KpiValue>{metrics.withBankDetailsCount}</KpiValue>
        <KpiSub>Проверены Р/с 20 знаков + БИК</KpiSub>
      </KpiCardBankDetails>
      <KpiCardSynced1C>
        <KpiLabel>Синхронизировано с 1С</KpiLabel>
        <KpiValue>{metrics.synced1CCount}</KpiValue>
        <KpiSub>Через API, выписки и документы</KpiSub>
      </KpiCardSynced1C>
      <KpiCardSuppliers>
        <KpiLabel>Поставщики и подрядчики</KpiLabel>
        <KpiValue>{metrics.activeSuppliersCount}</KpiValue>
        <KpiSub>Основной производственный контур</KpiSub>
      </KpiCardSuppliers>
    </KpiGrid>
  );
}
